const TextStyle = {

  subTitle: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '24px',
    color: '#252733',
  },

  label: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '10px',
    lineHeight: '20px',
    textAlign: 'start',
    letterSpacing: '0.2px',
    color: '#252733'
  },
  buttonDefault: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontHeight: '700',
    fontSize: '14px',
    lineHeight: '16px',
    textAlign: 'center'
  },
  textDescription: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '19px',
    color: '#252733'
  },
}

export default TextStyle;